// White-label branding helpers: convert hex colors to CSS rgb channels and
// inject them as runtime CSS variables so the whole app re-themes per tenant.

const DEFAULTS = {
  violet: "109 40 217",       // #6D28D9
  violetDeep: "91 33 182",    // #5B21B6
  violetLight: "139 92 246",  // #8B5CF6
  gold: "201 162 75",         // #C9A24B
};

function hexToRgb(hex) {
  if (!hex) return null;
  let h = hex.trim().replace("#", "");
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  if (h.length !== 6) return null;
  const n = parseInt(h, 16);
  if (Number.isNaN(n)) return null;
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
}

const channels = (rgb) => `${rgb.r} ${rgb.g} ${rgb.b}`;

function shade(rgb, factor) {
  // factor < 1 darkens, > 1 lightens (clamped 0..255)
  const c = (v) => Math.max(0, Math.min(255, Math.round(v * factor)));
  return { r: c(rgb.r), g: c(rgb.g), b: c(rgb.b) };
}

function lighten(rgb, amount) {
  const c = (v) => Math.max(0, Math.min(255, Math.round(v + (255 - v) * amount)));
  return { r: c(rgb.r), g: c(rgb.g), b: c(rgb.b) };
}

// Apply tenant branding to the document root. Passing an empty/undefined object
// resets to OMNIA defaults.
export function applyBranding(branding) {
  const root = document.documentElement;
  const primary = hexToRgb(branding?.primary);
  const accent = hexToRgb(branding?.accent);

  if (primary) {
    root.style.setProperty("--c-violet", channels(primary));
    root.style.setProperty("--c-violet-deep", channels(shade(primary, 0.82)));
    root.style.setProperty("--c-violet-light", channels(lighten(primary, 0.28)));
  } else {
    root.style.setProperty("--c-violet", DEFAULTS.violet);
    root.style.setProperty("--c-violet-deep", DEFAULTS.violetDeep);
    root.style.setProperty("--c-violet-light", DEFAULTS.violetLight);
  }
  root.style.setProperty("--c-gold", accent ? channels(accent) : DEFAULTS.gold);
}
